import { useNavigate } from 'react-router';

/** Volta para onde a pessoa estava; sem histórico no app (link direto), vai para a lista. */
export function useBackToNotes() {
  const navigate = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) void navigate(-1);
    else void navigate('/anotacoes');
  };
}
